/**
 * Beheert de persistentie van gebruikersstatistieken en dagelijkse metrics in Firestore.
 */
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';

/**
 * Haalt de statistieken van een gebruiker op voor een specifieke dag.
 * @param {string} userId
 * @param {string} dateStr - Formaat YYYY-MM-DD
 */
export const getUserStats = async (userId, dateStr) => {
  try {
    const statDocRef = doc(db, 'users', userId, 'stats', dateStr);
    const docSnap = await getDoc(statDocRef);
    return docSnap.exists() ? docSnap.data() : null;
  } catch (error) {
    console.error(
      `MetricsService: Error fetching stats for ${userId} on ${dateStr}:`,
      error,
    );
    throw error;
  }
};

/**
 * Slaat de statistieken van een gebruiker op voor een specifieke dag.
 * @param {string} userId
 * @param {string} dateStr - Formaat YYYY-MM-DD
 * @param {Object} stats
 */
export const saveUserStats = async (userId, dateStr, stats) => {
  try {
    const statDocRef = doc(db, 'users', userId, 'stats', dateStr);
    await setDoc(statDocRef, {
      ...stats,
      calculatedAt: new Date(),
    });
  } catch (error) {
    console.error(
      `MetricsService: Error saving stats for ${userId} on ${dateStr}:`,
      error,
    );
    throw error;
  }
};
